/**
 * States closed for hosting inventory. Pure predicates only - whether the
 * restriction applies is decided by useInventoryLocationRestrictions, which
 * limits it to the Gitcha public app. MLS tenants scope their own territory
 * via tenant.locationRestriction and some of them cover California, so never
 * call these directly from a component.
 */
const RESTRICTED_INVENTORY_STATES = {
  CA: "California",
};

const normalize = (value) => (value || "").toString().trim().toLowerCase();

// Accepts the short code ("CA") or the long name ("California") - which one
// Google returns depends on the address_components field read.
export const isRestrictedInventoryState = (state) => {
  const value = normalize(state);
  if (!value) return false;
  return Object.entries(RESTRICTED_INVENTORY_STATES).some(
    ([code, name]) => value === normalize(code) || value === normalize(name),
  );
};

// For a formatted address ("123 Main St, Los Angeles, CA 90012, USA"), used
// where only the display string is available such as autocomplete predictions.
export const isRestrictedInventoryAddress = (address) => {
  if (!address) return false;
  return Object.entries(RESTRICTED_INVENTORY_STATES).some(
    ([code, name]) =>
      new RegExp(`,\\s*(${code}|${name})(\\s|,|$)`, "i").test(address),
  );
};

// Accepts a state or a full address. Kept short: .error-msg renders uppercase
// at 11px in a fixed-height row, so a longer sentence wraps and clips.
export const restrictedInventoryStateMessage = (stateOrAddress) => {
  const value = normalize(stateOrAddress);
  const match = Object.entries(RESTRICTED_INVENTORY_STATES).find(
    ([code, name]) =>
      value === normalize(code) ||
      value === normalize(name) ||
      new RegExp(`,\\s*(${code}|${name})(\\s|,|$)`, "i").test(
        stateOrAddress || "",
      ),
  );
  const label = match ? match[1] : "this state";
  return `${label} is currently disabled.`;
};

export default RESTRICTED_INVENTORY_STATES;
